import React from 'react';
import postal from 'postal';
import { onRoadblockedClick, buildSignupUrl, buildNonRoadblockedUrl } from '../../../../utils/roadblocks';
import { wrapEventHandler } from '../../../../utils/handlers';

const createReactClass = require('create-react-class');

const RoadblockedAnchor = createReactClass({
  componentDidMount() {
    const messagingChannelName = 'explore_messagingChannel';
    this.messagingChannel = postal.channel(messagingChannelName);
  },
  onClick() {
    onRoadblockedClick(this.messagingChannel, this.props.event, this.props.currentUser, this.props.href, {
      atRef: this.props.atRef,
      returnToUrl: this.props.href,
      openInNewTab: this.props.openInNewTab
    });
  },
  render() {
    const anchorTarget = this.props.openInNewTab ? '_blank' : '_self';

    if (this.props.mobileBrowser) {
      if (!this.props.currentUser) {
        const href = buildSignupUrl(this.props.href, this.props.atRef);
        return <a id={this.props.cssId} className={this.props.cssClass} href={href} dangerouslySetInnerHTML={{ __html: this.props.innerHTML }} />;
      }

      return (
        <a
          href="#"
          id={this.props.cssId}
          className={this.props.cssClass}
          onClick={wrapEventHandler(this.onClick)}
          dangerouslySetInnerHTML={{ __html: this.props.innerHTML }}
        />
      );
    }
    const href = buildNonRoadblockedUrl(this.props.href, this.props.atRef);
    return (
      <a
        id={this.props.cssId}
        target={anchorTarget}
        className={this.props.cssClass}
        href={href}
        dangerouslySetInnerHTML={{ __html: this.props.innerHTML }}
      />
    );
  }
});

RoadblockedAnchor.defaultProps = {
  openInNewTab: false
};

export { RoadblockedAnchor };
